import { render, staticRenderFns } from "./ui-copy-textarea.vue?vue&type=template&id=106c648e&scoped=true&"
import script from "./ui-copy-textarea.vue?vue&type=script&lang=ts&"
export * from "./ui-copy-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./ui-copy-textarea.vue?vue&type=style&index=0&id=106c648e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c648e",
  null
  
)

export default component.exports